import { Component } from '@angular/core';

@Component({
  selector: 'app-security-pass',
  templateUrl: './security-pass.component.html',
  styleUrls: ['./security-pass.component.scss']
})
export class SecurityPassComponent {

}
